export const DOG = 'dog';
export const CAT = 'cat';
